import { Component, h, Host, Prop } from '@stencil/core';
import { resizeSVGsForEdge } from '../../../global/utils/utils';
export class IconComponent {
  constructor() {
    /**
     * The size of the icon to be displayed
     */
    this.size = 'sm';
    /**
     * Adds alt text to svg and images so that screen readers can announce the meaning of the image. Note this does not add the alt attribute but makes use of a hidden span tag to house the text
     */
    this.altText = '';
  }
  /**
   * This function is a temporary solution to deal with the pre chromium version of the Edge and will be removed once AGL update their SOE
   */
  componentDidLoad() {
    let dimension = '';
    switch (this.size) {
      case 'xxs':
        dimension = '16';
        break;
      case 'xs':
        dimension = '24';
        break;
      case 'sm':
        dimension = '32';
        break;
      case 'md':
        dimension = '48';
        break;
      case 'lg':
        dimension = '64';
        break;
    }
    //if a reference to svgSpan is present it means it is for svg icon that we need to manually set dimension for edge and IE. Note this does not add the alt attribute but makes use of a hidden span tag to house the text
    if (this.svgSpan) {
      resizeSVGsForEdge(this.svgSpan, dimension, dimension);
    }
  }
  render() {
    const isSvg = this.icon && this.icon.includes('<svg ') && this.icon.includes('</svg>');
    const imageSrc = this.icon ? this.icon : this.iconPath;
    return (h(Host, null,
      this.altText && h("span", { class: "sr-only" },
        "Image: ",
        this.altText),
      isSvg && (h("span", { ref: (el) => (this.svgSpan = el), "aria-hidden": "true", class: { icon: true, ['icon__size--' + this.size]: true }, innerHTML: this.icon })),
      !isSvg && (h("img", { "aria-hidden": this.iconAlt || this.iconCaption ? 'false' : 'true', alt: this.iconAlt, title: this.iconCaption, src: imageSrc, class: { icon: true, ['icon__size--' + this.size]: true } }))));
  }
  static get is() { return "agl-ds-icon"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["icon.component.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["icon.component.css"]
  }; }
  static get properties() { return {
    "icon": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The raw string of the icon (E.G Raw SVG or a base 64 encoded png perhaps)\nIf both iconPath and icon are set, icon will be preferred over iconPath"
      },
      "attribute": "icon",
      "reflect": false
    },
    "iconPath": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The path of the icon to be displayed"
      },
      "attribute": "icon-path",
      "reflect": false
    },
    "size": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "IconSize",
        "resolved": "\"lg\" | \"md\" | \"sm\" | \"xs\" | \"xxs\"",
        "references": {
          "IconSize": {
            "location": "import",
            "path": "./icon.types"
          }
        }
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The size of the icon to be displayed"
      },
      "attribute": "size",
      "reflect": false,
      "defaultValue": "'sm'"
    },
    "altText": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Adds alt text to svg and images so that screen readers can announce the meaning of the image. Note this does not add the alt attribute but makes use of a hidden span tag to house the text"
      },
      "attribute": "alt-text",
      "reflect": false,
      "defaultValue": "''"
    },
    "iconAlt": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Textual alternative of the meaning or function of the image, for visually impaired readers"
      },
      "attribute": "icon-alt",
      "reflect": false
    },
    "iconCaption": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Additional information about the image."
      },
      "attribute": "icon-caption",
      "reflect": false
    }
  }; }
}
